import styled from "styled-components";

export const StyledButton = styled.button`
    background-color: var(--main-text-color);
    color: var(--main-bg-color);
    font-size: 1.2rem;
    cursor: pointer;
`